module.exports = __webpack_public_path__ + "img/MED_FRUIT@300x.f0fb5518.png";